import React, { Dispatch, SetStateAction, useState } from 'react'
// Local
import { isNil } from 'ramda'
import Card from './card'
import { conditions as conditionsUtils } from '../common/conditionUtils'
import If from '../common/if'
import Accordion from './accordion'
import Condition from './condition'
import { KnownAndPotential } from './processConditions'
import {
  EncounterConditionDisplayModified,
  TagStatus,
  User
} from '../authenticated/types'

type Props = {
  currentUser: User
  conditions: KnownAndPotential[]
  tagsClicked: Record<string, TagStatus>
  setTagsClicked: Dispatch<SetStateAction<Record<string, TagStatus>>>
}

function ClinicalConditions(props: Props): JSX.Element {
  const { currentUser, conditions, tagsClicked, setTagsClicked } = props

  function getTitle(c: KnownAndPotential): string {
    const {hccDescription} = c.conditions[0]
    const {hccCode} = c.conditions[0]

    return ((!isNil(hccDescription) && hccDescription.length > 0) &&
      (!isNil(hccCode) && hccCode.length > 0)) ? hccDescription.concat(` (HCC ${hccCode})`) : ''
  }

  const renderedConditions = conditions.map(
    (c: KnownAndPotential, index: number) => {
      const areAllConditionsPotential = conditionsUtils.areAllPotential(
        c.conditions
      )

      const [
        required,
        setRequired
      ] = useState<number>(c.required)

      const otherConditionHccs = [ null, '', '0' ]

      return (
        <React.Fragment key={ `clinical-condition-${index + 1}` }>
          <If
            isTrue={ !otherConditionHccs.includes(c.conditions[0].hccCode) }
          >
            <Accordion
              id={ `clinical-condition-${index + 1}` }
              title={ getTitle(c) }
              isRequired={ required > 0 }
              isAddressed={ required === 0 && !!c.knownAddressed }
            >
              { c.conditions.map(
                (
                  subCondition: EncounterConditionDisplayModified,
                  nestedIndex: number
                ): JSX.Element => (
                  <Condition
                    id={ `condition-${index + 1}-nested-${nestedIndex + 1}` }
                    key={ subCondition.id }
                    currentUser={ currentUser }
                    conditions={ c.conditions }
                    condition={ subCondition }
                    isStandAloneCondition={ false }
                    areAllConditionsInGroupPotential={ areAllConditionsPotential }
                    required={ required }
                    setRequired={ setRequired }
                    tagsClicked={ tagsClicked }
                    setTagsClicked={ setTagsClicked }
                  />
                )
              ) }
            </Accordion>
          </If>

          <If
            isTrue={ otherConditionHccs.includes(c.conditions[0].hccCode) }
          >
            { c.conditions.map(
              (
                subCondition: EncounterConditionDisplayModified,
                nestedIndex: number
              ) => (
                <Card
                  key={ subCondition.id }
                  id={ `clinical-condition-${index + 1}` }
                >
                  <Condition
                    id={ `condition-${index + 1}-nested-${nestedIndex + 1}` }
                    key={ `condition-${index + 1}-nested-${nestedIndex + 1}` }
                    currentUser={ currentUser }
                    conditions={ c.conditions }
                    condition={ subCondition }
                    isStandAloneCondition={ true }
                    areAllConditionsInGroupPotential={ areAllConditionsPotential }
                    required={ required }
                    setRequired={ setRequired }
                    tagsClicked={ tagsClicked }
                    setTagsClicked={ setTagsClicked }
                  />
                </Card>
              )
            ) }
          </If>
        </React.Fragment>
      )
    }
  )

  return <>{ renderedConditions }</>
}

export default ClinicalConditions
